module.exports = __webpack_public_path__ + "2c0e01c937205a3ee839fa65b1a90431.MP3";